/**
 * Created by Christal on 2018/5/14.
 */

let defaulttoken = ''
let defaultusername = ''
let defaultpassword = ''
let defaultrole = ''
try {
  if (localStorage.token) {
    defaulttoken = localStorage.token
  }
} catch (e) {}

try {
  if (localStorage.username) {
    defaultusername = localStorage.username
  }
} catch (e) {}

try {
  if (localStorage.password) {
    defaultpassword = localStorage.password
  }
} catch (e) {}

try {
  if (localStorage.role) {
    defaultrole = localStorage.role
  }
} catch (e) {}

try {
  if (localStorage.ossAuth) {
    defaultOssAuth = localStorage.ossAuth
  }
} catch (e) {}

export default {
  token: defaulttoken,
  username: defaultusername,
  password: defaultpassword,
  role: defaultrole,
}



// WEBPACK FOOTER //
// ./src/store/state.js